import React from "react";

const formatAmount = (amount) => {
  const formatted = parseFloat(amount).toFixed(2);
  return formatted.replace(/\.?0+$/, '');
};

const Money = ({ amount, currency }) => {
  const currencySymbol = currency.toUpperCase() === 'EUR' ? '€' : 'лв.';

  return (
    <span className="money">
      <span className="amount">{formatAmount(amount)}</span>
      <span className="currency"> {currencySymbol}</span>
    </span>
  );
};

export default Money;
